window.widenUtils = function widenUtils() {};

widenUtils.getDimensionsFromAssetUrl = function(url) {
  // Returns object w/ width/height or null... should be at position 6 in array
  var a = url.split('/');
  if (a[6] !== undefined) {
    if (a[6].indexOf('px') != -1 && !isNaN(parseInt(a[6]))) {
      var b = a[6].split('x');
      return {
        width: parseInt(b[0]),
        height: parseInt(b[1])
      }
    }
  }
  return null;
}

widenUtils.getFixedWidthImage = function(id, name, width) {
  return 'https://embed.widencdn.net/img/springswindowfashions/' + id + '/' + width + 'px/' + name + '.jpg';
}

widenUtils.getImageNameFromAssetUrl = function(url) {
  var ind1 = url.lastIndexOf('/') + 1,
    ind2 = url.lastIndexOf('.');
  if (ind1 !== 0 && ind2 !== -1) {
    return url.substring(ind1, ind2);
  }
  return url;
}

widenUtils.getIdFromAssetUrl = function(url) {
  if (!url) {
    return url;
  }
  var urlPiece = url.match(/springswindowfashions\/(.*?)\//);
  if (urlPiece !== null) {
    return urlPiece[1]
  }
  return url;
}

widenUtils.setAssetCaption = function(id, url) {
    console.log('widenUtils.setAssetCaption');
    var caption = '';

    var callback = function() {
          // Find this item in the swatchbook then update the description
        var len = swatchbook.data.items.length,
            at;
        for (var i = 0; i < len; i++) {
            if (swatchbook.data.items[i].id === id) {
                at = i;
            }
        }
        if (at !== undefined) {
            swatchbook.data.items[at].description = caption;
            console.log('Updated the caption.');
            // Update data object in storage
            ls.setItemInObj(ls.cookies.swbk, swatchbook.data);
        }
    }

    if (url.indexOf('embed.widencdn.net') !== -1) { // check if Widen URL
        var data;
        var filename = widenUtils.getFileNameFromAssetUrl(url);
        var requestURL = '/api/service/damget';
        var request = new XMLHttpRequest();
            request.open('POST', requestURL, true);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        var requesting = true;
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                console.log('🎉 setAssetCaption');
                data = JSON.parse(request.responseText);
                console.log(data);
                if (data.items.length > 0) {
                    if (data.items[0].metadata.fields.webReadyCaption.length > 0) {
                        caption = data.items[0].metadata.fields.webReadyCaption[0];
                    } else {
                        caption = 'Description not available.';
                        console.warn('Image has no caption in Widen');
                    }
                } else {
                  caption = 'Description not available;'
                  console.warn('Image not found in Widen.');
                }
                callback();
            } else {
                console.log(request.responseText);
                console.log('widenUtils.setAssetCaption, server returned error');
            }
        };
        request.onerror = function () {
            console.log('widenUtils.setAssetCaption, connection error');
        };
        request.send(JSON.stringify({ data: '?query=' + filename + '&expand=embeds,thumbnails,metadata,metadata_info'}));
    } else { // not a Widen URL
        console.warn('Tried to find caption but it is not a Widen image.');
        caption = 'Description not available.';
        callback();
    }
}

widenUtils.getFileNameFromAssetUrl = function(url) {
  var name = url.substr(0, url.lastIndexOf('.'));
  name = name.substr(url.lastIndexOf('/') + 1);
  console.log('name', name);
  return name;
}
